var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" Purchase Order: " + _vm._s(_vm.entityName) + " "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderDetail.name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                            _vm.$v.detailGroup.$error,
                        },
                        attrs: {
                          "data-badge": _vm.$v.detailGroup.$error ? "" : null,
                        },
                      },
                      [_vm._v(" Detail Info ")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: { "is-disabled": !_vm.enableRoutes },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderVehicleCustomerInsurer
                          .name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      event: "",
                      exact: "",
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goToRoute({
                          name: _vm.routeTypes
                            .PurchaseOrderVehicleCustomerInsurer.name,
                          params: {
                            purchaseOrderId: _vm.$route.params.purchaseOrderId,
                          },
                          query: _vm.$route.query,
                        })
                      },
                    },
                  },
                  [_c("span", [_vm._v(" Other Info ")])]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderRemarks.name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [_c("span", [_vm._v(" Remarks ")])]
                ),
              ],
              1
            ),
          ]),
          _c("p", { staticClass: "menu-label" }, [_vm._v(" Items ")]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderOverview.name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [_c("span", [_vm._v(" Overview ")])]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderOtherPurchases.name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [
                    _c("span", [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v("Other Purchases"),
                      ]),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.otherPurchases.length,
                            expression: "otherPurchases.length",
                          },
                        ],
                        staticClass: "has-badge-rounded has-badge-medium",
                        class: [
                          _vm.$v.entity.otherPurchases.$error
                            ? "has-badge-danger"
                            : "has-badge-info",
                        ],
                        attrs: { "data-badge": _vm.otherPurchases.length },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: { "is-disabled": !_vm.enableRoutes },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderSublet.name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      event: "",
                      exact: "",
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goToRoute({
                          name: _vm.routeTypes.PurchaseOrderSublet.name,
                          params: {
                            purchaseOrderId: _vm.$route.params.purchaseOrderId,
                          },
                          query: _vm.$route.query,
                        })
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v("Sublet"),
                      ]),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.sublets.length,
                            expression: "sublets.length",
                          },
                        ],
                        staticClass:
                          "has-badge-rounded has-badge-medium has-badge-info",
                        attrs: { "data-badge": _vm.sublets.length },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: { "is-disabled": !_vm.enableRoutes },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderMisc.name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      event: "",
                      exact: "",
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goToRoute({
                          name: _vm.routeTypes.PurchaseOrderMisc.name,
                          params: {
                            purchaseOrderId: _vm.$route.params.purchaseOrderId,
                          },
                          query: _vm.$route.query,
                        })
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v("Misc"),
                      ]),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.miscs.length,
                            expression: "miscs.length",
                          },
                        ],
                        staticClass:
                          "has-badge-rounded has-badge-medium has-badge-info",
                        attrs: { "data-badge": _vm.miscs.length },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: { "is-disabled": !_vm.enableRoutes },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderParts.name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      event: "",
                      exact: "",
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goToRoute({
                          name: _vm.routeTypes.PurchaseOrderParts.name,
                          params: {
                            purchaseOrderId: _vm.$route.params.purchaseOrderId,
                          },
                          query: _vm.$route.query,
                        })
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v("Parts"),
                      ]),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.parts.length,
                            expression: "parts.length",
                          },
                        ],
                        staticClass:
                          "has-badge-rounded has-badge-medium has-badge-info",
                        attrs: { "data-badge": _vm.parts.length },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    class: { "is-disabled": !_vm.enableReceiptRoutes },
                    attrs: {
                      to: {
                        name: _vm.routeTypes.PurchaseOrderOrderReceipt.name,
                        params: {
                          purchaseOrderId: _vm.$route.params.purchaseOrderId,
                        },
                        query: _vm.$route.query,
                      },
                      "active-class": "is-active",
                      event: "",
                      exact: "",
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goToReceiptRoute({
                          name: _vm.routeTypes.PurchaseOrderOrderReceipt.name,
                          params: {
                            purchaseOrderId: _vm.$route.params.purchaseOrderId,
                          },
                          query: _vm.$route.query,
                        })
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v("Order Receipt"),
                      ]),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.orderReceipts.length,
                            expression: "orderReceipts.length",
                          },
                        ],
                        staticClass: "has-badge-rounded has-badge-medium",
                        class: [
                          _vm.$v.entity.orderReceipts.$error
                            ? "has-badge-danger"
                            : "has-badge-info",
                        ],
                        attrs: { "data-badge": _vm.orderReceipts.length },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }